/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { TextField } from '@material-ui/core';
import React, { useCallback, useState } from 'react';

const CMSDrugURATextFieldComponent = (props) => {
  const [value, setValue] = useState(props.value);

  const checkedHandler = (e) => {
    const inputValue = e.target.value;

    if (/^\d*\.?\d{0,6}$/.test(inputValue) || inputValue === '') {
      setValue(inputValue);
      props.node.setDataValue(props.column.colId, inputValue);

      if (props.validateBtnDisable) {
        props.validateBtnDisable(props);
      }

      if (props.onChange) {
        props.onChange(inputValue);
      }

      // 👉 Auto-clear "Please Enter New URA." if input is valid
      if (
        props.setErrorMessage &&
        props.errorMessage &&
        props.errorMessage.includes('Please Enter New URA.') &&
        inputValue.trim() !== ''
      ) {
        const filteredErrors = props.errorMessage.filter(
          (msg) => msg !== 'Please Enter New URA.'
        );
        props.setErrorMessage(filteredErrors);
      }
    }
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 300);
    };
  };

  const optimiseValidationCall = useCallback(
    debounce(props.validateBtnDisable),
    []
  );
  const handleBlur = () => {
    const colId = props.column.colId;
    const currentValue = value;

    if (
      currentValue !== '' &&
      currentValue !== null &&
      /^\d*\.?\d{0,6}$/.test(currentValue)
    ) {
      if (props.validateBtnDisable) {
        props.validateBtnDisable(props);
      }
    }
  };

  return (
    <div className="fullWidth w-100">
      <TextField
        fullWidth
        placeholder=""
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{ maxlength: 21 }}
        InputProps={{ disableUnderline: true }}
        value={value || ''}
        onChange={checkedHandler}
        onBlur={handleBlur} // <--- Add this
        disabled={
          props.isEnablebyRole ||
          props.hasAccess !== true ||
          props.column.colId === 'unitRebateAmt' ||
          props.column.colId === 'cmsDrugIdVO.qtr'
            ? true
            : false
        }
      />
    </div>
  );
};

export default CMSDrugURATextFieldComponent;
